/**
 * Tournament Module document repository (ADR-031 P2).
 * Capability of Arena — NOT an aggregate root.
 * Path: `arenas/{arenaId}/modules/tournament`
 */

import { doc, getDoc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

export const TOURNAMENT_MODULE_ID = "tournament";

function moduleRef(arenaId) {
  return doc(db, "arenas", arenaId, "modules", TOURNAMENT_MODULE_ID);
}

/**
 * @param {string} arenaId
 */
export async function fetchTournamentModule(arenaId) {
  if (!arenaId) return null;
  const snap = await getDoc(moduleRef(arenaId));
  if (!snap.exists()) return null;
  return { id: snap.id, arenaId, moduleId: TOURNAMENT_MODULE_ID, ...snap.data() };
}

/**
 * @param {string} arenaId
 * @param {Record<string, unknown>} data
 */
export async function setTournamentModule(arenaId, data) {
  await setDoc(
    moduleRef(arenaId),
    {
      ...data,
      moduleId: TOURNAMENT_MODULE_ID,
      arenaId,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

/**
 * @param {string} arenaId
 * @param {(doc: object | null) => void} onData
 */
export function subscribeTournamentModule(arenaId, onData) {
  if (!arenaId) {
    onData?.(null);
    return () => {};
  }
  return onSnapshot(moduleRef(arenaId), (snap) => {
    if (!snap.exists()) {
      onData?.(null);
      return;
    }
    onData?.({ id: snap.id, arenaId, moduleId: TOURNAMENT_MODULE_ID, ...snap.data() });
  });
}
